import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Tooltip from '@mui/material/Tooltip'
import DeleteOutline from '@mui/icons-material/DeleteOutline'
import { LIST_ACTION_DELETE_BUTTON_SX } from './listActionIconStyles'
import { FORM_DIALOG_ACTION_BUTTON_SX, FORM_DIALOG_DANGER_ACTION_BUTTON_SX } from './BottomButtonGroup'

export default function DeleteAlertDialog( props ) {
    const [open, setOpen] = useState(false)
    const disabled = Boolean(props.disabled)

    const handleClickOpen = () => {
        if (disabled) {
            return
        }
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleCloseDelete = () => {
        if (disabled) {
            return
        }
        setOpen(false)
        props.handleDelete(props.id)
        
    }

    return (
        <>
            <Tooltip title="Delete">
                <Box
                    component="button"
                    type="button"
                    onClick={handleClickOpen}
                    aria-label="Delete"
                    aria-disabled={disabled}
                    sx={{
                        ...LIST_ACTION_DELETE_BUTTON_SX,
                        cursor: disabled ? 'default' : 'pointer',
                        opacity: disabled ? 0.5 : 1,
                        color: disabled ? 'text.disabled' : LIST_ACTION_DELETE_BUTTON_SX.color,
                    }}
                >
                    <DeleteOutline />
                </Box>
            </Tooltip>
            <Dialog
                open={open}
                onClose={disabled ? undefined : handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                {"정말 데이터를 삭제하시겠습니까?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {/* 데이터를 삭제하시겠습니까? */}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus disabled={disabled} variant="outlined" color="secondary" sx={FORM_DIALOG_ACTION_BUTTON_SX}>Cancel</Button>
                    <Button onClick={handleCloseDelete} disabled={disabled} variant="contained" color="error" sx={FORM_DIALOG_DANGER_ACTION_BUTTON_SX}>Delete</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
